export const TypeClassMapper: Record<number, string> = {
    1: 'bg-primary',
    2: 'bg-secondary',
    3: 'bg-success',
    4: 'bg-info',
    5: 'bg-warning',
    6: 'bg-light text-dark',
    7: 'bg-dark',
}